import { render, staticRenderFns } from "./LaStoria.vue?vue&type=template&id=34441fdc&scoped=true"
import script from "./LaStoria.vue?vue&type=script&lang=js"
export * from "./LaStoria.vue?vue&type=script&lang=js"
import style0 from "./LaStoria.vue?vue&type=style&index=0&id=34441fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34441fdc",
  null
  
)

export default component.exports